var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayeredStepsHaikei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#140021"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 396L129 396L129 389L257 389L257 383L386 383L386 364L514 364L514 408L643 408L643 407L771 407L771 395L900 395L900 390L900 601L900 601L771 601L771 601L643 601L643 601L514 601L514 601L386 601L386 601L257 601L257 601L129 601L129 601L0 601Z",
    fill: "#9900ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 443L129 443L129 450L257 450L257 452L386 452L386 444L514 444L514 428L643 428L643 434L771 434L771 458L900 458L900 458L900 601L900 601L771 601L771 601L643 601L643 601L514 601L514 601L386 601L386 601L257 601L257 601L129 601L129 601L0 601Z",
    fill: "#8200d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 476L129 476L129 504L257 504L257 497L386 497L386 477L514 477L514 499L643 499L643 475L771 475L771 495L900 495L900 474L900 601L900 601L771 601L771 601L643 601L643 601L514 601L514 601L386 601L386 601L257 601L257 601L129 601L129 601L0 601Z",
    fill: "#6c00b4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 554L129 554L129 535L257 535L257 529L386 529L386 553L514 553L514 555L643 555L643 533L771 533L771 557L900 557L900 546L900 601L900 601L771 601L771 601L643 601L643 601L514 601L514 601L386 601L386 601L257 601L257 601L129 601L129 601L0 601Z",
    fill: "#560090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredStepsHaikei);
export default __webpack_public_path__ + "static/media/layered-steps-haikei.6390db074566e65ee1f565dd0ff04d66.svg";
export { ForwardRef as ReactComponent };